/*
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import { useDashboardData } from 'hooks/useDashboardState'
import { usePageConfigUser } from 'hooks/usePageConfig'
import Sharing from 'enums/Sharing'
import SharingEditing from 'enums/SharingEditing'

export const useIsDashboardOwner = () => {
  const dashboardData = useDashboardData()
  const user = usePageConfigUser()

  if (dashboardData && user) {
    return dashboardData.ownerInfo.id === Number(user.userProfileId)
  }
  return false
}

export const useEditSharingDashboardAccess = () => {
  const userConfig = usePageConfigUser()
  return userConfig?.featureTest?.split(',').includes('editsharingdashboard')
}

export const useIsSharedWithAnalyst = () => {
  const dashboardData = useDashboardData()
  const isOwner = useIsDashboardOwner()
  const hasEditSharingDashboardAccess = useEditSharingDashboardAccess()

  const isNotNewDashboard = !!dashboardData && !!dashboardData?.ownerInfo

  return (
    isNotNewDashboard &&
    !isOwner &&
    dashboardData.sharing !== Sharing.PRIVATE &&
    dashboardData.sharingEditing === SharingEditing.SHARED_WITH_ANALYSTS &&
    hasEditSharingDashboardAccess
  )
}
